export * from './post-honorar-vereinbarung.component';
export * from './post-honorar-vereinbarung.component.module';